import TextBanner from './TextBanner';

export default TextBanner;
